import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 1500,
  height: "auto",
  margin: "0 auto",
  padding: "30px 10px",

  [theme.down("xl")]: {
    maxWidth: 1200,
  },

  [theme.down("lg")]: {
    maxWidth: 1000,
  },

  [theme.down("md")]: {
    maxWidth: 800,
  },

  [theme.down("sm")]: {
    maxWidth: 600,
  },

  [theme.down("xs")]: {
    width: "100%",
    padding: "0px 20px",
  },
}));

export const Title = styled("h1")(({ theme }) => ({
  fontSize: 28,
  marginTop: 20,
  marginBottom: 20,
}));

export const List = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5,1fr)",
  gap: 30,
  padding: "20px 0",

  a: {
    fontSize: "18px",
    color: "#4299e1",
    textDecoration: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    display: "block",
    transition: "background-color 0.2s ease",

    "&:hover": {
      backgroundColor: "#ebf8ff",
      color: "#2b6cb0",
    },
  },

  [theme.down("xl")]: {
    gridTemplateColumns: "repeat(3,1fr)",
  },

  [theme.down("lg")]: {
    gridTemplateColumns: "repeat(2,1fr)",
  },

  [theme.down("xs")]: {
    placeItems: "center",
    gridTemplateColumns: "repeat(1, 1fr)",
    paddingLeft: 15,
  },
}));
